<form [formGroup]="creditCardForm" (yatSubmit)="submitForm($event)" (submitTried)="activateInvalidCardType()">
  <div class="row">
    <div class="col-12">
      <div class="form-group">
        <label for="holder-name">{{ 'checkout.paymentInformation.creditCardForm.cardHolder.label' | transloco }}</label>
        <input
          type="text"
          class="form-control"
          id="holder-name"
          formControlName="holderName"
          [placeholder]="'checkout.paymentInformation.creditCardForm.cardHolder.placeholder' | transloco"
          maxlength="40"
          yatAutoFocus
          yatInput />
        <div class="invalid-feedback" [ngSwitch]="creditCardForm.controls.holderName.errors | classifyValidationError">
          <span *ngSwitchCase="'required'">{{ 'checkout.paymentInformation.creditCardForm.cardHolder.validators.required' | transloco }}</span>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="form-group">
        <label for="number">{{ 'checkout.paymentInformation.creditCardForm.cardNumber.label' | transloco }}</label>
        <div class="input-group" [class.active]="focused === true" [class.filled]="isNotEmpty === true">
          <input
            type="text"
            class="form-control border-right-0 no-validation-background input-prepend-box-shadow"
            id="number"
            inputmode="numeric"
            pattern="[0-9 ]*"
            formControlName="number"
            mask="0000 0000 0000 0000 000"
            [dropSpecialCharacters]="false"
            [validation]="false"
            maxlength="23"
            [yatInput]="true" />
          <div class="input-group-append">
            <div class="input-group-text">
              <yat-icon id="00b65d23-27f1-4e22-b378-e457e4cd169b"
                *ngIf="cardType$ | async"
                [name]="cardType$ | async | cardTypeIcon"
                [title]="cardType$ | async | cardTypeDescription | async"
                [multiColored]="true"></yat-icon>
            </div>
          </div>
        </div>
        <div
          class="invalid-feedback"
          [ngSwitch]="number.errors | classifyValidationError"
          [class.ng-invalid]="number.invalid"
          [class.ng-touched]="number.touched">
          <span *ngSwitchCase="'required'">{{ 'checkout.paymentInformation.creditCardForm.cardNumber.validators.required' | transloco }}</span>
          <span *ngSwitchCase="'numberFormat'">{{ 'checkout.paymentInformation.creditCardForm.cardNumber.validators.numberFormat' | transloco }}</span>
          <span *ngSwitchCase="'cardType'">{{ 'checkout.paymentInformation.creditCardForm.cardNumber.validators.cardType' | transloco }}</span>
          <span *ngSwitchCase="'invalidCardNumber'">{{
            'checkout.paymentInformation.creditCardForm.cardNumber.validators.invalidCardNumber' | transloco
          }}</span>
        </div>
      </div>
    </div>
    <div class="col-5 pr-2">
      <div class="form-group">
        <label for="expiry">{{ 'checkout.paymentInformation.creditCardForm.cardExpiry.label' | transloco }}</label>
        <input
          type="text"
          class="form-control"
          id="expiry"
          formControlName="expiry"
          inputmode="numeric"
          pattern="[0-9\/]*"
          [specialCharacters]="['/', 'm', 'y']"
          [dropSpecialCharacters]="false"
          [showMaskTyped]="showMask"
          shownMaskExpression="mm/yy"
          mask="M0/00"
          maxlength="10"
          spellcheck="false"
          (focus)="showMask = true"
          (blur)="showMask = false"
          yatInput />
        <div class="invalid-feedback" [ngSwitch]="expiry.errors | classifyValidationError">
          <span *ngSwitchCase="'required'">{{ 'checkout.paymentInformation.creditCardForm.cardExpiry.validators.required' | transloco }}</span>
          <span *ngSwitchCase="'expiryFormat'">{{ 'checkout.paymentInformation.creditCardForm.cardExpiry.validators.expiryFormat' | transloco }}</span>
          <span *ngSwitchCase="'expiryDateInvalid'">{{
            'checkout.paymentInformation.creditCardForm.cardExpiry.validators.expiryDateInvalid' | transloco
          }}</span>
          <span *ngSwitchCase="'cardExpired'">{{ 'checkout.paymentInformation.creditCardForm.cardExpiry.validators.cardExpired' | transloco }}</span>
        </div>
      </div>
    </div>
    <div class="col-5 pl-2 pr-0">
      <div class="form-group">
        <label for="cvc">{{ 'checkout.paymentInformation.creditCardForm.cardCvc.label' | transloco }}</label>
        <yat-tooltip-info-icon
          iconClass="ml-1"
          tooltipClass="tooltip-xl"
          [tooltipContent]="'checkout.paymentInformation.creditCardForm.cardCvc.tooltip' | transloco">
        </yat-tooltip-info-icon>
        <input
          type="text"
          class="form-control cvv2"
          id="cvc"
          formControlName="cvc"
          maxlength="5"
          inputmode="numeric"
          pattern="[0-9]*"
          autocomplete="off"
          yatInput />
        <div class="invalid-feedback" [ngSwitch]="creditCardForm.controls.cvc.errors | classifyValidationError">
          <span *ngSwitchCase="'required'">{{ 'checkout.paymentInformation.creditCardForm.cardCvc.validators.required' | transloco }}</span>
          <span *ngSwitchCase="'cvc'">{{ 'checkout.paymentInformation.creditCardForm.cardCvc.validators.cvc' | transloco }}</span>
          <span *ngSwitchCase="'cvcDeclined'">{{ 'checkout.paymentInformation.creditCardForm.cardCvc.validators.cvcDeclined' | transloco }}</span>
        </div>
      </div>
    </div>
  </div>
  <yat-buttons
    [primaryButtonName]="('saveAndContinue' | commonWording | async) ?? ''"
    [secondaryButtonName]="('back' | commonWording | async) ?? ''"
    (secondaryButtonClickMethod)="cancel()"
    [className]="buttonsClassName"
    [matomoEventCategory]="MATOMO_EVENT_CATEGORY_PAYMENT"
    matomoEventClickPrimaryButtonAction="Confirm_PaymentMethodForm"
    matomoEventClickSecondaryButtonAction="Cancel_PaymentMethodForm"
    matomoEventName="Creditcard">
  </yat-buttons>
</form>
